import { Link } from '@tanstack/react-router';
import { ChevronRight, FolderOpen } from 'lucide-react';

/**
 * Raccourci vers « Mes fichiers » sur les pages « Mes contacts ». Les barres de
 * navigation MOBILES (tuteur : 5 emplacements pleins ; élève : symétrique autour
 * du bouton central) ne reçoivent pas d'entrée supplémentaire : c'est ici que le
 * mobile y accède. Bloc fixe, hors `CONTACT_SECTIONS` (pas une liste à personnaliser).
 */
export function FilesShortcut({ to }: { to: '/tutor/files' | '/student/files' }) {
  return (
    <Link
      to={to}
      className="border-ink-100 flex min-h-[2.75rem] items-center gap-3 rounded-2xl border bg-white p-3 transition-colors active:scale-[0.98]"
    >
      <span className="bg-primary-50 text-primary-600 flex size-10 shrink-0 items-center justify-center rounded-xl">
        <FolderOpen className="size-5" aria-hidden />
      </span>
      <span className="min-w-0 flex-1">
        <span className="text-ink-900 block text-sm font-semibold">Mes fichiers</span>
        <span className="text-ink-500 block truncate text-xs">
          Documents partagés avec tes contacts, tes classes et en réunion
        </span>
      </span>
      <ChevronRight className="text-ink-400 size-4 shrink-0" aria-hidden />
    </Link>
  );
}
